import { steps } from "../../helper";
import "./style.scss";

function Working() {
  return (
    <div className="content flex flex-col items-center">
      <span className="font-title-normal leading-5">How it works</span>
      <p className="mt-1 font-body-normal leading-5 description">
        It’s super easy to refer a friends. Give it to go!
      </p>
      <div className="flex justify-evenly gap-3 mt-2-5 relative w-full">
        {steps.map((step, index) => (
          <div
            className="working-step-item flex flex-col items-center relative"
            key={index}
          >
            <div className="icon-circle">
              <step.icon />
            </div>
            <div className="step-label">{step.label}</div>
            {index < steps.length - 1 && (
              <div
                className={`connector ${index % 2 === 0 ? "connector-up" : "connector-down"}`}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default Working;
